module.exports = __webpack_public_path__ + "img/collection_logo.ecdbe4fc.svg";